import { TBaseItem } from "@centricsoftware/design-system";
import { cnl, IDataStoreNamesItem, Operator, relationDataStoreId } from "c8-platform";
import DataStoreNamesStore from "csi/components/select/store/DataStoreNamesStore";
import { TYPE_ENUM, TYPE_ENUM_VALUE } from "csi/reflection/reflectionConstants";
import siteDefaultLocale from "csi/siteDefaultLocale";
import xml from "csi/xml";
import Query from "csi/xml/Query";
import { ILocaleProvider } from "designSystem/locale";

class ConfigurableEnumValueSelectStore extends DataStoreNamesStore {
	constructor(enumList: string, enumListUrl: cnl) {
		const query = new Query().Attr("Active", Operator.EQUALS, true);
		const params = {
			dataStoreId: relationDataStoreId(TYPE_ENUM, "Values", TYPE_ENUM_VALUE),
			queryXml: query.toString(),
			sourceUrl: enumListUrl,
		};

		const transform = ({ name, url }: IDataStoreNamesItem, loc: ILocaleProvider): TBaseItem => {
			const id = xml.enumCreate(enumList, name);
			const localizedName = siteDefaultLocale.getResourceIfExists(id) || name;

			return {
				id,
				name: localizedName,
			};
		};

		super(params, transform);
	}
}

export default ConfigurableEnumValueSelectStore;